
import Accordion from './Accordion';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';



function Bairhuggerwarming() {



  const cardData =
  {
    keyword: '3M Bair Hugger Warming Blanket',
    heading: 'Pharmacle Health Care Private Limited: 3M Bair Hugger Warming Blanket',
    headingDescription: 'The 3M™ Bair Hugger™ Warming Blanket is a widely used forced-air warming system designed to maintain patient normothermia during surgical procedures. Introduced in 1987 and now manufactured by 3M, the system comprises a reusable warming unit connected to single-use, disposable blankets. Warm air is circulated through the blanket via a flexible hose, exiting through micro-perforations to evenly warm the patient is skin in areas not involved in the surgical procedure.',

    top: 'Pharmacle Health Care Private Limited – Leading Provider of Forced Air-Warming Systems & Blankets',


"topPlaces": [
  {
    "title": "3M™ Bair Hugger™ Warming Blanket ",
    "description": "The 3M™ Bair Hugger™ Warming Blanket is a globally recognized solution for preventing perioperative hypothermia. Using advanced forced-air warming technology, it maintains patient normothermia before, during, and after surgical procedures, enhancing safety, comfort, and surgical outcomes."
  },
  {
    "title": "Top Choice for Patient Warming – 3M Bair Hugger™ System",
    "description": "Designed with precision and safety, the 3M Bair Hugger™ system delivers warm air through specialized perforations in the blanket, ensuring even heat distribution. It supports a wide range of surgical procedures, from general to complex surgeries, and is widely used in top hospitals around the world."
  },
  {
    "title": "Versatile and Effective – 3M™ Bair Hugger™ Warming Blankets",
    "description": "With options including upper-body, lower-body, full-body, and underbody blankets, the 3M Bair Hugger™ offers versatile applications. Each blanket is made from soft, radiolucent, and latex-free materials, making it safe for imaging procedures and minimizing cross-contamination risks."
  },
  {
    "title": "3M Bair Hugger™ System ",
    "description": "Known for its reliability and efficiency, the Bair Hugger™ system is an essential tool in maintaining core body temperature. Its proven ability to reduce surgical site infections and other complications makes it a trusted component in surgical temperature management."
  },
  {
    "title": "Buy 3M Bair Hugger™ Warming Blanket in India",
    "description": "The 3M Bair Hugger™ Warming Blanket is available in India through medical suppliers like HospitalStore.in, Medikabazaar, and Desertcart. Trusted by healthcare providers, these blankets are ideal for improving patient outcomes and are compatible with 3M's warming units."
  },
  {
    "title": "3M Bair Hugger™ 63000, 31500, and 62200 Models",
    "description": "Choose from various models such as the 63000 sterile cardiac blanket, 31500 multi-access design, and 62200 multi-position upper body warming option. Each model caters to specific surgical needs while ensuring uniform thermal support for patients."
  },
  {
    "title": "Safe, Single-Use Warming Blankets from 3M",
    "description": "Engineered for single-use, 3M Bair Hugger™ blankets are hygienic, effective, and built to provide consistent convective warming. Integrated features such as head drapes and adhesive strips improve blanket positioning and patient coverage."
  },
  {
    "title": "3M Bair Hugger™ ",
    "description": "Clinical studies have demonstrated the 3M Bair Hugger™ system’s effectiveness in reducing risks of hypothermia, a common challenge during long surgeries. Its easy-to-use interface and efficient heating process make it an indispensable part of the surgical workflow."
  },
  {
    "title": "Radiolucent and Imaging-Friendly Warming Blankets",
    "description": "3M’s Bair Hugger™ warming blankets are designed to be radiolucent, allowing for imaging without the need to remove the blanket. This feature improves workflow in critical care and surgical environments while maintaining patient warmth."
  },
  {
    "title": "Explore 3M Bair Hugger™ ",
    "description": "Hospitals across the globe rely on 3M Bair Hugger™ Warming Blankets for superior thermal management. Whether it's for general surgery, orthopedics, or cardiothoracic procedures, this system remains the gold standard in patient warming."
  }
],

"services": [
    {
        "name": "3M Bair Hugger Warming Blanket",
        "description": "Pharmacle Health Care offers the 3M Bair Hugger Warming Blanket, designed to regulate patient body temperature during medical procedures. This advanced forced air warming blanket helps prevent hypothermia by maintaining a stable temperature, ensuring patient safety and comfort during surgeries, recovery, and critical care. Trusted by healthcare professionals worldwide, it is a vital part of surgical temperature management."
    },
    {
        "name": "Bair Hugger Forced Air Blanket",
        "description": "We provide the Bair Hugger Forced Air Blanket, a reliable solution for maintaining patient warmth during medical treatments. The Bair Hugger system uses forced air technology to ensure consistent body temperature regulation, preventing hypothermia during surgeries, recovery, and critical care procedures. It is a trusted product for healthcare providers to improve patient safety and recovery."
    },
    {
        "name": "3M Surgical Warming Blanket",
        "description": "Pharmacle Health Care offers the 3M Surgical Warming Blanket, specifically designed to regulate body temperature during surgical procedures. This blanket utilizes advanced forced air warming technology to ensure patients remain at a safe and comfortable temperature, reducing the risk of hypothermia and improving surgical outcomes. It’s a reliable solution for temperature management in the operating room."
    },
    {
        "name": "Bair Hugger Patient Warming Blanket",
        "description": "We offer the Bair Hugger Patient Warming Blanket, which is essential for maintaining optimal body temperature in patients during surgery or recovery. This blanket uses forced air warming technology to safely regulate temperature, reducing the risk of hypothermia and enhancing patient comfort. It is trusted by medical professionals for its effectiveness in temperature management and patient care."
    },
    {
        "name": "Bair Hugger Thermoregulation Blanket",
        "description": "The Bair Hugger Thermoregulation Blanket is designed to ensure stable body temperature during medical procedures. Using advanced forced air warming technology, this blanket helps prevent hypothermia, promotes recovery, and enhances patient comfort. Pharmacle Health Care provides this reliable solution for temperature regulation in hospitals, surgical centers, and other healthcare facilities."
    },
    {
        "name": "Bair Hugger Blanket Distributors India",
        "description": "Pharmacle Health Care is a leading distributor of Bair Hugger blankets in India, offering a range of temperature management solutions for medical procedures. Our Bair Hugger blankets are trusted by hospitals and healthcare professionals across India to ensure patient safety, comfort, and effective hypothermia prevention during surgeries and critical care treatments."
    },
    {
        "name": "3M Hospital Warming Systems",
        "description": "We supply 3M Hospital Warming Systems, designed to provide effective thermal regulation for patients during surgeries and medical treatments. These systems, including the Bair Hugger warming blankets, help prevent hypothermia and ensure patient comfort and safety. Pharmacle Health Care’s 3M Warming Systems are a trusted solution for hospitals across India to optimize patient care."
    },
    {
        "name": "Operating Room Blanket by 3M",
        "description": "Pharmacle Health Care offers the Operating Room Blanket by 3M, a vital solution for regulating patient body temperature during surgeries. This blanket uses forced air technology to provide consistent warmth, preventing hypothermia and improving recovery times. It is a trusted product for operating rooms and critical care settings, ensuring the safety and comfort of every patient."
    }
],
"tableData": [
    ["- 3M Bair Hugger Warming Blanket", "- Bair Hugger Forced Air Blanket", "- 3M Surgical Warming Blanket"],
    ["- Bair Hugger Patient Warming Blanket", "- Bair Hugger Thermoregulation Blanket", "- Bair Hugger Blanket Distributors India"],
    ["- 3M Hospital Warming Systems", "- Operating Room Blanket by 3M"]
],

"whychoose": [
    {
        "WhyChooseheading": "Advanced and Reliable Warming Technology",
        "WhyChoosedescription": "The 3M Bair Hugger Warming Blanket is an advanced and reliable warming solution designed to provide precise and consistent temperature control. It effectively prevents hypothermia during surgical procedures by delivering gentle, controlled warmth to the patient."
    },
    {
        "WhyChooseheading": "Comprehensive Patient Warming Solutions",
        "WhyChoosedescription": "The 3M Bair Hugger Warming Blanket is part of a comprehensive patient warming solution that includes various models and accessories tailored to meet the needs of healthcare providers. It is suitable for a wide range of medical treatments, ensuring patient comfort and safety throughout the procedure."
    },
    {
        "WhyChooseheading": "High-Quality, Durable Equipment",
        "WhyChoosedescription": "Manufactured by 3M, the Bair Hugger Warming Blanket is built with high-quality materials designed for durability and long-term performance. This product is rigorously tested to meet safety and performance standards, ensuring reliable operation in busy healthcare environments."
    },
    {
        "WhyChooseheading": "Safe and Comfortable for Patients",
        "WhyChoosedescription": "Patient safety and comfort are paramount. The 3M Bair Hugger Warming Blanket provides even, controlled warmth that helps maintain the patient's core temperature during surgeries, preventing complications like hypothermia and improving recovery times."
    },
    {
        "WhyChooseheading": "Flexible Solutions for Healthcare Providers",
        "WhyChoosedescription": "The 3M Bair Hugger Warming Blanket is adaptable for use in various healthcare settings, including operating rooms, recovery rooms, and intensive care units. It offers flexible warming solutions to meet the diverse needs of healthcare providers, ensuring patient safety during critical procedures."
    },
    {
        "WhyChooseheading": "Easy Integration with Existing Systems",
        "WhyChoosedescription": "The 3M Bair Hugger Warming Blanket is designed for easy integration with existing medical systems. Its user-friendly design allows for seamless operation in medical environments, helping healthcare professionals maintain efficient and effective patient care."
    },
    {
        "WhyChooseheading": "Expert Consultation and Support",
        "WhyChoosedescription": "3M offers expert consultation and support to healthcare facilities using the Bair Hugger Warming Blanket. With professional guidance and ongoing support, healthcare providers can ensure optimal use and maintenance of the equipment for maximum patient safety and effectiveness."
    },
    {
        "WhyChooseheading": "Commitment to Patient Safety and Comfort",
        "WhyChoosedescription": "3M is committed to patient safety and comfort with its Bair Hugger Warming Blanket. Designed to maintain the patient's core body temperature during critical medical procedures, it helps to reduce risks associated with temperature fluctuations, ensuring patients receive the highest standard of care."
    }
]



















  }

  const faqData = [
    {
      question: "What is the 3M Bair Hugger Warming Blanket?",
      answer: "The 3M Bair Hugger Warming Blanket is a patient warming product used to help maintain normal body temperature during surgery. It works with a warming unit to blow warm air through the specially designed blanket, helping prevent hypothermia."
    },
    {
      question: "How does the 3M Bair Hugger system work?",
      answer: "The system includes a warming unit and a single-use blanket. The unit heats filtered air and gently circulates it through the perforated warming blanket placed over or under the patient, providing uniform warmth throughout the procedure."
    },
    {
      question: "Is the 3M Bair Hugger Warming Blanket safe for all surgeries?",
      answer: "Yes, the Bair Hugger system is widely used in a variety of surgical procedures and is considered safe when used as directed. It is especially effective for preventing perioperative hypothermia."
    },
    {
      question: "Are there alternatives to the 3M Bair Hugger in India?",
      answer: "Yes, alternatives such as the Forced Air Warming Systems from manufacturers like Pharmacle Health Care Private Limited are available in India. These systems offer similar performance in maintaining patient body temperature."
    },
    {
      question: "Can the 3M Bair Hugger Warming Blanket be reused?",
      answer: "No, the warming blanket component is designed for single use to maintain hygiene and prevent cross-contamination. The warming unit itself is reusable and compatible with various blanket models."
    }
  ];
  
  const testimonialsData = [
    {
      text: "We’ve used the 3M Bair Hugger system in our ORs for years. It’s effective, easy to operate, and enhances patient safety by reducing the risk of hypothermia.",
      name: "Dr. Priya Nambiar, Sunrise Surgical Center"
    },
    {
      text: "Bair Hugger warming blankets provide excellent thermal management during long procedures. The airflow is well-distributed and comfortable for patients.",
      name: "CarePlus Multispecialty Hospital"
    }
  ];
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  

  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  























  const contactData = {
    heading: `${cardData.keyword} Contact Number`,
    contactNumbers: [
      "+91 8956322311",
      "+91 8421773700",

    ],
    email: "info@wallabieswarmcares.com"
  };


const Images = [
  {
    place: "/images/keyword/1.jpg",
    text: "Patient Forced Air Warming System in Pune",
    link: "/Patient-Forced-Air-Warming-System-in-Pune",
  },
  {
    place: "/images/keyword/2.jpg",
    text: "Patient Forced Air Warming Blankets in Delhi",
    link: "/Patient-Forced-Air-Warming-Blankets-in-Delhi",
  },
  {
    place: "/images/keyword/3.jpg",
    text: "Patient Forced Air Warmer in Mumbai",
    link: "/Patient-Forced-Air-Warmer-in-Mumbai",
  },
  {
    place: "/images/keyword/5.jpg",
    text: "Patient Warming Systems in Chennai",
    link: "/Patient-Warming-Systems-in-Chennai",
  },
  {
    place: "/images/keyword/6.jpg",
    text: "Patient Warmer in Bengaluru",
    link: "/Patient-Warmer-in-Bengaluru",
  },
  {
    place: "/images/keyword/7.jpg",
    text: "Normothermia Equipment in Hyderabad",
    link: "/Normothermia-Equipment-in-Hyderabad",
  },
  {
    place: "/images/keyword/8.jpg",
    text: "Patient Thermoregulation System in Ahmedabad",
    link: "/Patient-Thermoregulation-System-in-Ahmedabad",
  },
  {
    place: "/images/keyword/9.jpg",
    text: "Patient Warming Devices in Kolkata",
    link: "/Patient-Warming-Devices-in-Kolkata",
  },
  {
    place: "/images/keyword/10.jpg",
    text: "Patient Warming Blankets in Jaipur",
    link: "/Patient-Warming-Blankets-in-Jaipur",
  },
  {
    place: "/images/keyword/12.jpg",
    text: "Patient Forced Air Warming System in Surat",
    link: "/Patient-Forced-Air-Warming-System-in-Surat",
  },
  {
    place: "/images/keyword/13.jpg",
    text: "Forced Air Warming Blankets in Coimbatore",
    link: "/Forced-Air-Warming-Blankets-in-Coimbatore",
  },
  {
    place: "/images/keyword/14.jpg",
    text: "Patient Warming Blankets in Lucknow",
    link: "/Patient-Warming-Blankets-in-Lucknow",
  },
  {
    place: "/images/keyword/15.jpg",
    text: "Patient Forced Air Warmer in Chandigarh",
    link: "/Patient-Forced-Air-Warmer-in-Chandigarh",
  },
  {
    place: "/images/keyword/17.jpg",
    text: "Thermoregulation Systems in Indore",
    link: "/Thermoregulation-Systems-in-Indore",
  },
  {
    place: "/images/keyword/18.jpg",
    text: "Patient Warming Systems in Patna",
    link: "/Patient-Warming-Systems-in-Patna",
  },
  {
    place: "/images/keyword/19.jpg",
    text: "Patient Forced Air Warming System in Hyderabad",
    link: "/Patient-Forced-Air-Warming-System-in-Hyderabad",
  },
  {
    place: "/images/keyword/20.jpg",
    text: "Patient Forced Air Warming Blankets in Delhi NCR",
    link: "/Patient-Forced-Air-Warming-Blankets-in-Delhi-NCR",
  },
  {
    place: "/images/keyword/21.jpg",
    text: "Forced Air Warming System in Noida",
    link: "/Forced-Air-Warming-System-in-Noida",
  },
  {
    place: "/images/keyword/22.jpg",
    text: "Patient Warming Devices in Bhopal",
    link: "/Patient-Warming-Devices-in-Bhopal",
  },
  {
    place: "/images/keyword/23.jpg",
    text: "Patient Warming Blankets in Kochi",
    link: "/Patient-Warming-Blankets-in-Kochi",
  },
  {
    place: "/images/keyword/24.jpg",
    text: "Patient Warming System in Pune",
    link: "/Patient-Warming-System-in-Pune",
  },
  {
    place: "/images/keyword/25.jpg",
    text: "Forced Air Warming Blankets in Bengaluru",
    link: "/Forced-Air-Warming-Blankets-in-Bengaluru",
  },
  {
    place: "/images/keyword/26.jpg",
    text: "Patient Warming Devices in Chennai",
    link: "/Patient-Warming-Devices-in-Chennai",
  },
  {
    place: "/images/keyword/27.jpg",
    text: "Patient Thermoregulation System in Surat",
    link: "/Patient-Thermoregulation-System-in-Surat",
  },
];


  const images = [
    { src: "/images/keyword/1.jpg", alt: "Image 1" },
    { src: "/images/keyword/5.jpg", alt: "Image 1" },
    { src: "/images/keyword/2.jpg", alt: "Image 1" },
    { src: "/images/keyword/18.jpg", alt: "Image 1" },
    { src: "/images/keyword/4.jpg", alt: "Image 1" },
    { src: "/images/keyword/7.jpg", alt: "Image 1" },
    { src: "/images/keyword/8.jpg", alt: "Image 1" },
    { src: "/images/keyword/19.jpg", alt: "Image 1" },
    { src: "/images/keyword/6.jpg", alt: "Image 1" },

  ];



  
  

  
  const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "3M Bair Hugger Warming Blanket",
  "image": "https://wallabieswarmcares.com/images/keyword/52.png",
  "description": "Shop 3M Bair Hugger Warming Blankets – advanced patient warming solutions including forced air blankets, surgical warming systems, and thermoregulation blankets for hospital and operating room use in India.",
  "brand": {
    "@type": "Brand",
    "name": "3M"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",
    "reviewCount": "1582",
    "bestRating": "5",
    "worstRating": "1"
  },
  "review": {
    "@type": "Review",
    "reviewRating": {
      "@type": "Rating",
      "ratingValue": "5",
      "bestRating": "5"
    },
    "author": {
      "@type": "Person",
      "name": "Dr. Meera Iyer"
    },
    "reviewBody": "We've used the 3M Bair Hugger blanket in over 200 surgical cases—reliable, safe, and quick warming. Highly recommended for ORs."
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "4200",
    "availability": "https://schema.org/InStock",
    "url": "https://wallabieswarmcares.com/3m-bair-hugger-warming-blanket"
  }
};


  return (
    <div>
<Helmet>
    <title>3M Bair Hugger Warming Blanket | Contact: +91 8956322311</title>
    <meta
      name="description"
      content="Buy 3M Bair Hugger Warming Blankets in India. Distributors of surgical patient warming blankets, forced air thermoregulation systems, and operating room warming solutions. Call +91 8956322311."
    />
    <meta
      name="keywords"
      content="3M Bair Hugger Warming Blanket, Bair Hugger Forced Air Blanket, 3M Surgical Warming Blanket, Bair Hugger Patient Warming Blanket, Bair Hugger Thermoregulation Blanket, Bair Hugger Blanket Distributors India, 3M Hospital Warming Systems, Operating Room Blanket by 3M"
    />
    <script type="application/ld+json">
      {JSON.stringify(jsonData)}
    </script>
  </Helmet>
      <div className="breadcrumbs overlay">
        <div className="container">
          <div className="bread-inner">
            <div className="row">
              <div className="col-12">
                <h2>{cardData.keyword}</h2>
              </div>
            </div>
          </div>
        </div>
      </div>



      <section>
        <div className="container-fluid" >
          <div className="row container-fluid pt-5">
            <div className="col-12 col-md-7 ">
              <img src='/images/keyword/52.png' alt='img' />
              <h3 className="py-1 pt-4"
                style={{
                  color: '#1A76D1', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3>

              <p className='fw-bold lead text-dark'>{cardData.headingDescription}</p>
              <div className="">
                <p className='fw-bold py-3 text-dark'>{cardData.top}</p>
                {cardData.topPlaces.map((place, index) => (
                  <div key={index} className="">
                    <div
                      style={{
                        cursor: 'pointer',
                        padding: '10px',
                        marginBottom: '7px',
                        borderRadius: '8px', // Optional: rounded corners
                        transition: 'transform 0.2s' // Optional: smooth scaling effect
                      }}
                    // Centers text within the card
                    >
                      <h4 className="mb-1 darkcolor">{place.title}</h4>
                      <p className="mb-0">{place.description}</p>
                    </div>
                  </div>
                ))}
              </div>
              <div
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  marginBottom: '7px',
                  borderRadius: '8px', // Optional: rounded corners
                  transition: 'transform 0.2s' // Optional: smooth scaling effect
                }}
              >
                {cardData.services.map((service, index) => (
                  <div key={index} className=" my-4">
                    <h4 className="py-1 darkcolor">{service.name}</h4>
                    <p>{service.description}</p>
                  </div>
                ))}
              </div>

              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
            

              <div id="why-choose-section"
                className='px-2'>
                {cardData.whychoose.map((item, index) => (
                  <div key={index}>
                    <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                    <p>{item.WhyChoosedescription}</p>
                  </div>
                ))}
              </div>
              <div>
                <h3 className='Colo'>FAQs {cardData.keyword} for  Pharmacle Health Care Private Limited</h3>
              
                <Accordion data={faqData} />
              </div>
              <div className='py-3'>
            
                <TestimonialKeyword testimonials={testimonialsData} />


              </div>

              <div className='pb-5'>

                <div className="contact-box Borderr ">
                  <h3>{contactData.heading}</h3>
                  <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                  <div className="contact-details ">
                    <ul>
                      {contactData.contactNumbers.map((number, index) => (
                        <li key={index}>
                          <a href={`tel:${number}`} className="contact-link fw-bold d-inline "><p className='d-inline'><strong className='darkcolor d-inline'>Mobile No:</strong></p>
                            {number}
                          </a>
                        </li>
                      ))}
                    </ul>
                    <p><strong className='darkcolor'>Email Id: </strong>
                      <a href={`mailto:${contactData.email}`} className="contact-link">
                        {contactData.email}
                      </a>
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className='col-12 col-md-4'>
              {Images.map((e) => {
                return (
                  <div className="box1">
                    <a href={e.link} className="d-flex justify-content-around align-items-center">
                      <div className="b1">
                        <img src={e.place} alt="img" />
                      </div>
                      <div className="b2">
                        <a href={e.link} className='px-3'>{e.text}</a>
                      </div>
                    </a>
                  </div>
                );
              })}



              <div className="gallery-container">
                <h2 className="gallery-title darkcolor">Our Gallery</h2>
                <div className="row">
                  {images.map((image, index) => (
                    <div className="gallery-item col-md-4" key={index}>
                      <img
                        src={image.src}
                        alt={image.alt}
                        className="gallery-image"

                      />
                    </div>
                  ))}

                </div>
              </div>

              <div className=" rounded p-4 shadow-sm Uni_border"
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  border: '3px solid #1A76D1',
                  marginBottom: '7px',
                  fontWeight: 'bold',
                }}

              >
                <h4 className="pb-3 pt-3  fw-bold text-bluee text-center">Contact Information</h4>

                <div className="row">

                  <div className="col-12 mb-3 rounded">
                    <div className="Small_border rounded  text-center  " style={{ backgroundColor: '#1A76D1' }}>
                      <div>
                        <h4 className=" lead fw-semibold whitt ">Phone Numbers</h4>
                      </div>

                      <div className=''>
                        <a href="tel:+918956322311" className="d-block  text-white">
                          <i className="fas fa-phone darkcolorrr colored me-2"></i>+91 8956322311
                        </a>
                        <a href="tel:+918421773700" className="d-block  text-white">
                          <i className="fas fa-phone darkcolorrr colored me-2"></i>+91 8421773700
                        </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3 ">
                    <div className="Small_border rounded text-center">

                      <div className='rounded ' style={{ backgroundColor: '#1A76D1' }}>
                        <h4 className=" fw-semibold lead whitt">Email</h4>
                        <a href="mailto:info@wallabieswarmcares.com" className=" text-white d-block">
                          <i className="fas fa-envelope darkcolorrr"></i> info@wallabieswarmcares.com
                        </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center">

                      <div className='rounded ' style={{ backgroundColor: '#1A76D1' }}>
                        <h4 className=" fw-semibold lead whitt">Address</h4>
                        <p className=" text-white ">
                          <i className="fas fa-map-marker-alt darkcolorrr"></i>  Pharmacle Health Care Private Limited <br />
                          Gat No. 1251/2/3/1252 Plot No. 28, Block Sector, Weikfield Industrial Estate, Pune - Nagar Road, Sanaswadi, Pune, Maharashtra, 412208


                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Bairhuggerwarming;